import { action, computed, observable } from "mobx";

import { IRootStore } from "@shared-types/root/root-store.interface.ts";

export class IntegrationScreenHelper {
  constructor(private root: IRootStore) {}
  @observable
  public showPhysitrackProviderList: boolean = false;
  @observable
  public numberOfActivatedProviders: number = 0;
  @observable
  public organisationError: string | undefined = undefined;

  @action
  public setNumberOfActivatedProviders = (value: number) => {
    this.numberOfActivatedProviders = value;
  };
  @action
  public setShowPhysitrackProviderList = (value: boolean) => {
    this.showPhysitrackProviderList = value;
  };

  @action
  public setOrganisationError = (value: string | undefined) => {
    this.organisationError = value;
  };

  @observable
  public showXeroConfigurationCard: boolean = false;

  @action
  public setShowXeroConfigurationCard = (value: boolean) => {
    this.showXeroConfigurationCard = value;
  };

  @computed
  public get xeroTenantId() {
    return this.root.customIntegrationXero.tenantId;
  }

  @computed
  public get xeroTenants() {
    return this.root.customIntegrationXero.tenants ?? [];
  }
}
